import { FC, useState, useRef } from 'react'
import Svg from '@components/svg'
import {
  StyleFooter,
  StyleMessageInputWrapper,
  StyleMessageInput,
  StyleMessageActionsRow,
  StyleMessageInputColumn,
} from './style'
import Files from './files'
import Button from '@components/button'
import { useSocket } from '@providers/SocketProvider'
import { useSelector } from 'react-redux'
import imageCompression from 'browser-image-compression'
import { Formik, Form } from 'formik'
import { store, Actions } from '@store'
const SupportMessageFooter = ({ receiver, sender }) => {
  const { socket }: any = useSocket()
  const browseRef = useRef<any>(null)
  const [initialValues] = useState({
    message: '',
    files: [],
  })
  const [loading, setLoading] = useState<boolean>(false)
  const room = useSelector((state: any) => state.supportRoom)
  const handleChangeFiles = async (
    e: any,
    setFieldValue: any,
    oldFiles = [],
  ) => {
    const filesArray = Array.from(e.target.files)
    const files = await Promise.all(
      filesArray.map(async (file: File) => {
        const fileName = file.name
        const extension = fileName.split('.').pop()?.toLowerCase() || ''
        let compressedFile = file
        if (file.type.startsWith('image/')) {
          compressedFile = await imageCompression(file, {
            maxSizeMB: 3,
            maxWidthOrHeight: 1024,
            useWebWorker: true,
          })
        }

        return new Promise<{
          base64: string
          extension: string
          info: string
          fileName: string
        }>((resolve, reject) => {
          const reader = new FileReader()
          reader.onload = () => {
            if (reader.result) {
              const base64String = reader.result.toString()
              const [info, base64] = base64String.split(',')
              resolve({ base64: base64.trim(), extension, info, fileName })
            } else {
              reject(new Error('File reading failed'))
            }
          }
          reader.onerror = reject
          reader.readAsDataURL(compressedFile)
        })
      }),
    )
    setFieldValue('files', [...files, ...oldFiles])
    e.target.files = null
  }
  const handleRemoveFile = (index, setFieldValue, oldFiles) => {
    const filterValues = oldFiles?.filter((_, i: number) => index != i)
    setFieldValue('files', filterValues)
  }
  const submitHandler = async (values: any, { resetForm }) => {
    if (!receiver?.id || (!values?.message && !values?.files?.length)) return
    const payload: any = {
      message: values?.message,
      receiverId: receiver?.id,
      receiver,
      sender: {
        id: sender?.id,
        name: sender?.name,
        avatar: sender?.avatar,
      },
    }
    if (!!values?.files?.length) {
      payload.files = values?.files?.map((value: any) => {
        return {
          base64: value?.base64,
          extension: value?.extension,
          filename: value?.fileName,
        }
      })
    }
    if (room?.id) {
      payload.supportId = room?.id
    }
    const dispatch: any = {
      id: 0,
      senderId: sender?.id,
      receiverId: receiver?.id,
      infos: {
        message: values?.message,
      },
      createdAt: new Date(),
    }
    if (!!values?.files && values?.files?.length) {
      dispatch.infos = {
        ...dispatch?.infos,
        files: values?.files,
      }
    }
    store.dispatch(Actions.prepend('supportMessages', dispatch))
    await socket.emit('sendSupportMessage', payload)
    resetForm()
    setLoading(false)
  }
  return (
    <StyleFooter>
      <Formik initialValues={initialValues} onSubmit={submitHandler}>
        {({ handleSubmit, setFieldValue, values }: any) => {
          return (
            <Form onSubmit={handleSubmit}>
              <StyleMessageInputColumn>
                {!!values?.files?.length && (
                  <Files
                    files={values?.files}
                    onRemoveFile={(index) => {
                      handleRemoveFile(index, setFieldValue, values?.files)
                    }}
                  />
                )}
                <StyleMessageInputWrapper>
                  <StyleMessageInput
                    placeholder="Type Message"
                    value={values?.message}
                    onChange={(e) => {
                      setFieldValue('message', e.target.value, values?.files)
                    }}
                  />
                  <StyleMessageActionsRow>
                    <Button
                      type="button"
                      height={35}
                      bg="secondary150"
                      styleButton="
                    border-radius:50%;
                    width:35px;
                    padding:0px;
                "
                      onClick={() => {
                        browseRef.current.click()
                      }}
                    >
                      <input
                        type="file"
                        name="files"
                        style={{ display: 'none' }}
                        multiple
                        onChange={(e: any) => {
                          handleChangeFiles(e, setFieldValue, values?.files)
                        }}
                        ref={browseRef}
                      />
                      <Svg svg="fileUpload" size={18} color={'secondary'} />
                    </Button>
                    <Button
                      disabled={loading}
                      type="submit"
                      bg="secondary150"
                      height={35}
                      styleButton="
                    border-radius:50%;
                    width:35px;
                    padding:0px;
                "
                    >
                      <Svg svg="send" size={18} color={'secondary'} />
                    </Button>
                  </StyleMessageActionsRow>
                </StyleMessageInputWrapper>
              </StyleMessageInputColumn>
            </Form>
          )
        }}
      </Formik>
    </StyleFooter>
  )
}

export default SupportMessageFooter
